import shallow from 'zustand/shallow'

import { useLoginStore, useTimerStore, useSettingsStore } from 'stores'

const FILE_NAME = 'Era_timers_v2.json'

const useGoogleAppdata = () => {
  const isLoggedIn = useLoginStore(state => state.isLoggedIn)
  const setIsLoading = useLoginStore(state => state.setIsLoading)
  const setTimers = useTimerStore(state => state.setTimers)
  const setId = useTimerStore(state => state.setId)
  const setSettings = useSettingsStore(state => state.setSettings)
  
  const timerStore = useTimerStore(state => ({
    timers: state.timers,
    id: state.id,
    dateUpdated: state.dateUpdated,
  }), shallow)
  const settingsStore = useSettingsStore(state => ({
    theme: state.theme,
    showSeconds: state.showSeconds,
    dateFormat: state.dateFormat,
    showConfetti: state.showConfetti,
    useGridLayout: state.useGridLayout,
  }), shallow)

  const load = async () => {
    if (!isLoggedIn) return

    setIsLoading(true)
    console.log('Loading from google drive')
    window.gapi.client.drive.files.list({
      spaces: 'appDataFolder',
      fields: 'nextPageToken, files(id, name)',
      pageSize: 100,
    }).then((res) => {
      const file = res.result.files.find(f => f.name.toLowerCase() === FILE_NAME.toLowerCase())
      if (file) {
        window.gapi.client.drive.files.get({
          fileId: file.id,
          alt: 'media',
        }).then(data => {
          console.log(data.result)
          if (data.result.timerStore.id !== timerStore.id && timerStore.timers.length > 0) {
            console.log('Different timers in google and localstorage, not syncing')
            if (window.confirm('You have different data backed up in your drive, would you like to overwrite your local countdown timers with the backed up data?')) {
              // Sync data from google drive
              setId(data.result.timerStore.id)
              setTimers(data.result.timerStore.timers)
              setSettings(data.result.settingsStore)
            }
          } else if (data.result.timerStore.id === timerStore.id && data.result.timerStore.dateUpdated < timerStore.dateUpdated) {
            console.log('Localstorage has fresher data, do not sync')
            save()
          } else {
            // Sync data from google drive
            setId(data.result.timerStore.id)
            setTimers(data.result.timerStore.timers)
            setSettings(data.result.settingsStore)
          }
          setIsLoading(false)
        })
      } else {
        console.log('Drive empty')
        setIsLoading(false)
        save()
      }
    })
  }

  const save = async () => {
    if (!isLoggedIn) return
    
    console.log('Saving to google drive')
    let file = new Blob(
      [JSON.stringify({
        timerStore,
        settingsStore,
      })],
      {
        type: 'application/json'
      }
    )
    let metadata = {
      name: FILE_NAME,
      mimeType: 'application/json',
      parents: ['appDataFolder'],
    }

    let accessToken = window.gapi.auth.getToken().access_token
    let form = new FormData()
    form.append('metadata', new Blob([JSON.stringify(metadata)], {type: 'application/json'}))
    form.append('file', file)

    let xhr = new XMLHttpRequest()
    xhr.open('post', 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id')
    xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken)
    xhr.responseType = 'json'
    xhr.onload = () => console.log(xhr.response)
    xhr.send(form)
  }

  return { load, save }
}

export default useGoogleAppdata